import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconZoom = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 28 28",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("radialGradient", {
			id: "a",
			cx: 14,
			cy: 12.373,
			r: 18.876,
			fx: 14,
			fy: 12.373,
			gradientTransform: "matrix(1 0 0 .83578 0 2.032)",
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .82,
				stopColor: "#0b5cff",
				stopOpacity: 0
			}), /* @__PURE__ */ _jsx("stop", {
				offset: .98,
				stopColor: "#003cb3"
			})]
		}), /* @__PURE__ */ _jsxs("radialGradient", {
			id: "b",
			cx: 14,
			cy: 15.621,
			r: 18.869,
			fx: 14,
			fy: 15.621,
			gradientTransform: "matrix(1 0 0 .83578 0 2.565)",
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .8,
				stopColor: "#0b5cff",
				stopOpacity: 0
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#71a5f1"
			})]
		})] }),
		/* @__PURE__ */ _jsx("path", {
			d: "M28 14c0 1.497-.12 2.965-.35 4.396a11.202 11.202 0 0 1-9.254 9.254 27.706 27.706 0 0 1-8.792 0A11.202 11.202 0 0 1 .35 18.397a27.705 27.705 0 0 1 0-8.793A11.202 11.202 0 0 1 9.604.35a27.706 27.706 0 0 1 8.792 0 11.202 11.202 0 0 1 9.254 9.253c.23 1.432.35 2.9.35 4.397Z",
			style: { fill: "#0b5cff" }
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28 14c0 1.497-.12 2.965-.35 4.396a11.202 11.202 0 0 1-9.254 9.254 27.706 27.706 0 0 1-8.792 0A11.202 11.202 0 0 1 .35 18.397a27.705 27.705 0 0 1 0-8.793A11.202 11.202 0 0 1 9.604.35a27.706 27.706 0 0 1 8.792 0 11.202 11.202 0 0 1 9.254 9.253c.23 1.432.35 2.9.35 4.397Z",
			style: { fill: "url(#a)" }
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28 14c0 1.497-.12 2.965-.35 4.397a11.202 11.202 0 0 1-9.254 9.253 27.703 27.703 0 0 1-8.792 0A11.202 11.202 0 0 1 .35 18.397a27.702 27.702 0 0 1 0-8.794A11.202 11.202 0 0 1 9.604.35a27.703 27.703 0 0 1 8.792 0 11.202 11.202 0 0 1 9.254 9.253c.23 1.432.35 2.9.35 4.397Z",
			style: { fill: "url(#b)" }
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23 23H5V5h18v18Z",
			style: { fill: "none" }
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17 17.5a1.5 1.5 0 0 1-1.5 1.5H9a3 3 0 0 1-3-3v-5.5A1.5 1.5 0 0 1 7.5 9H14a3 3 0 0 1 3 3v5.5Zm3.8-7.6-2.2 1.65a1.5 1.5 0 0 0-.6 1.2v2.5c0 .472.222.917.6 1.2l2.2 1.65a.75.75 0 0 0 1.2-.6v-7a.75.75 0 0 0-1.2-.6Z",
			style: { fill: "#fff" }
		})
	]
});
export default SvgIconZoom;
